import classnames from 'classnames';
import { forwardRef } from 'react';
import CaptureManager from './CaptureManager/CaptureManager';
import CaptureManagerProvider, { CaptureManagerStateContext } from './CaptureManager/context';
import Webcam from './Webcam/Webcam';
import './WebcamRecorder.css';
import CaptureProvider from './Webcam/context';
import { CaptureHandle, WebcamRecorderProps } from './Webcam/context/type';

const WebcamRecorder = forwardRef<CaptureHandle, WebcamRecorderProps>(
  (
    {
      study,
      assign,
      params,
      appearance = 'default',
      setRecording,
      actionUpload,
      open,
      modal,
      onSelect,
      onUploading,
    },
    ref
  ) => {
    if (!open) return null;

    return (
      <div
        className={classnames('capture-video flex flex-col pb-0.5 lg:h-auto lg:overflow-hidden', {
          // 'lg:h-auto': selectedResolution.width < selectedResolution.height,
        })}
      >
        <CaptureManagerProvider {...{ actionUpload, appearance, params, study, onUploading }}>
          <CaptureProvider setRecording={setRecording} ref={ref}>
            <CaptureManagerStateContext.Consumer>
              {(value) => (value.showCamera ? <Webcam /> : null)}
            </CaptureManagerStateContext.Consumer>
          </CaptureProvider>

          <CaptureManager modal={modal} onSelect={onSelect} />
        </CaptureManagerProvider>
      </div>
    );
  }
);

export default WebcamRecorder;
